import { useContext } from "react";
import { UserRoleNames } from "common/authorization";
import { AuthContext } from "../../../../../../Authorization/AuthContext";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../form/form";
import { RoleAndGroupSelector } from "../../RoleAndGroupSelector";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";
import { DisplaySettings } from "./shared/DisplaySettings";
import { FieldPermissionsConfig } from "./shared/FieldPermissionsConfig";
import { FieldSettingsConfig } from "./shared/FieldSettingsConfig";
import { HelperTextInput } from "./shared/HelperTextInput";
import { PlaceholderTextInput } from "./shared/PlaceholderTextInput";
import { RandomizeOptionOrderCheckbox } from "./shared/RandomizeOptionOrderCheckbox";

export function UserWidgetSettings({
  fieldPath,
  isReadOnly,
  isModuleInput,
}: InputSettingsFormProps) {
  const { control } = useBuilderFormContext();
  const { account } = useContext(AuthContext);
  const userGroups = account?.userGroups || [];

  const userGroupSelectionPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "userGroupSelection",
  );

  return (
    <WidgetSettingsContainer>
      <FieldSettingsConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={false}
        isReadOnly={isReadOnly}
      />
      <PlaceholderTextInput fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <HelperTextInput fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <RoleAndGroupSelector
        label="Which user groups should be displayed in the dropdown?"
        control={control}
        name={userGroupSelectionPropertyFormPath}
        options={{
          roles: [...UserRoleNames],
          userGroups,
        }}
        iconName="users-round"
      />
      <RandomizeOptionOrderCheckbox
        fieldPath={fieldPath}
        isReadOnly={isReadOnly}
      />
      <FieldPermissionsConfig fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <DisplaySettings fieldPath={fieldPath} isReadOnly={isReadOnly} />
    </WidgetSettingsContainer>
  );
}
